import Image from "@components/Image";
import Icons from "@gstyles/styleguide/icons";
import useSwiper from "@hooks/useSwiper";
import cx from "classnames";
import { useMemo, useState } from "react";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import styles from "./ImagesGallery2.module.scss";
import _ from "lodash";

interface Props {
  galleryRef?: any;
  galleryName: string;
  images: { src: string; alt: string }[];
  className?: string | { [key: string]: string };
  itemClassName?: string | { [key: string]: string };
  imageClassName?: string | { [key: string]: string };
  scrollbar?: { width: number; height: number };
  onSlideChange?: (swiper: any) => void;
}

// const formatPaginationNumber = (
//   locales?: string,
//   options?: Intl.NumberFormatOptions
// ) => {
//   return (value: number) =>
//     new Intl.NumberFormat(
//       locales ?? "de-DE",
//       options ?? { minimumIntegerDigits: 2 }
//     ).format(value);
// };

export default function ImagesGallery2({
  galleryRef = {},
  images,
  galleryName,
  className,
  itemClassName,
  imageClassName,
  scrollbar = { width: 170, height: 1 },
  onSlideChange,
}: Props) {
  const [_activeIndex, $activeIndex] = useState(0);
  const [xAxis, setXAxis] = useState(0);
  const widthScrollbarDrag = useMemo(
    () => scrollbar.width / images.length,
    [scrollbar, images.length]
  );
  galleryRef.current = useSwiper(`.${galleryName}`, {
    rewind: true,
    speed: 1000,
    parallax: true,
    slidesPerView: 1,
    grabCursor: false,
    centeredSlides: true,
    pagination: {
      el: `.swiper-${galleryName}-pagination`,
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: `.swiper-${galleryName}-next`,
      prevEl: `.swiper-${galleryName}-prev`,
    },
    on: {
      slideChange: (swiper) => {
        if (swiper) {
          setXAxis(widthScrollbarDrag * (swiper?.realIndex ?? 0));
          $activeIndex(swiper.realIndex);
          onSlideChange?.(swiper);
        }
      },
    },
  });
  // const formatFractionNumber = formatPaginationNumber();
  if (images.length === 1) {
    return (
      <div className={cx(styles.wrapperImage)}>
        <Image
          // animated={false}
          scale={1}
          speed={0}
          wrapperProps={{
            className: cx(styles.image, imageClassName),
          }}
          src={_.get(images, "0.src")}
          alt={_.get(images, "0.alt")}
          layout="fill"
          objectFit="cover"
        />
      </div>
    );
  }
  return (
    <div className={cx(styles.section, className)}>
      <div className={cx(styles.swiperBox)}>
        <div className={cx(styles.swiper, `${galleryName}`, "swiper")}>
          <div className={cx("swiper-wrapper")}>
            {images.map((img, index) => {
              return (
                <div
                  key={`img_${index}_${img.alt}`}
                  className={cx("swiper-slide", styles.item, itemClassName)}
                >
                  <div className={cx(styles.wrapperImage)}>
                    <div className={cx(styles.leftGradientBg)} />
                    <Image
                      scale={1}
                      speed={0}
                      wrapperProps={{
                        className: cx(styles.image, imageClassName),
                      }}
                      src={_.get(img, "src", "")}
                      alt={_.get(img, "alt", "")}
                      layout="fill"
                      objectFit="cover"
                    />
                    <div className={cx(styles.rightGradientBg)} />
                    <div className={cx(styles.bgGradient)} />
                  </div>
                </div>
              );
            })}
          </div>
          <Icons
            name="chevron-left-outline"
            color={"#F7EEDF"}
            className={cx(`swiper-${galleryName}-prev`, styles.prevChevronIcon)}
          />
          <Icons
            name="chevron-right-outline"
            color={"#F7EEDF"}
            className={cx(`swiper-${galleryName}-next`, styles.nextChevronIcon)}
          />
          {/* <div className={cx(styles.pagination)}>
            <div className={cx(styles.fraction)}>{`${formatFractionNumber(
              activeIndex + 1
            )} / ${formatFractionNumber(images.length)}`}</div>
            <div
              className={cx(`swiper-${galleryName}-pagination`, styles.bullets)}
            />
          </div> */}
          <div className={cx(styles.navigation)}>
            <Icons
              name="arrow-long-narrow-right"
              color="#FFFFFF"
              className={cx(`swiper-${galleryName}-prev`, styles.prevArrowIcon)}
            />
            <Icons
              name="arrow-long-narrow-right"
              color="#FFFFFF"
              className={cx(`swiper-${galleryName}-next`, styles.nextArrowIcon)}
            />
          </div>
        </div>
        <div
          className={cx(styles.scrollbarCustom)}
          style={{
            width: `${scrollbar.width}px`,
            height: `${scrollbar.height}px`,
          }}
        >
          <div
            className={cx(styles.scrollbarDrag)}
            style={{
              width: `${widthScrollbarDrag}px`,
              transform: `translate3d(${xAxis}px, 0px, 0px)`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
